import { render } from "./JoinGame.vue?vue&type=template&id=56e87ce8&scoped=true"
import script from "./JoinGame.vue?vue&type=script&lang=js"
export * from "./JoinGame.vue?vue&type=script&lang=js"

import "./JoinGame.vue?vue&type=style&index=0&id=56e87ce8&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e87ce8"]])

export default __exports__